import React from 'react'
import PrivateLayout from '../components/PrivateLayout'
import Footer from '../components/Footer'
import OrganizationSummary from '../components/OrganizationSummary'
import { useNavigate } from 'react-router-dom'

const Settings = (): JSX.Element => {
  const navigate = useNavigate()

  return (
    <PrivateLayout>
      <div className="content">
        <OrganizationSummary showSettingsLabel />

        <h3 className="mb-4">Grant Areas</h3>
        <div className="row">
          <div className="col-xl-9">
            <form className="row g-3 mb-6">
              <div className="col-sm-6 col-md-6">
                <div className="form-floating">
                  <input className="form-control" id="floatingInputBudget" type="text" placeholder="value" />
                  <label htmlFor="floatingInputBudget">Humility-in-Theology</label>
                </div>
              </div>

              <div className="col-sm-4 col-md-4">
                <div className="form-floating">
                  <input className="form-control" id="floatingInputBudget" type="text" placeholder="key" />
                  <label htmlFor="floatingInputBudget">hit</label>
                </div>
              </div>

              <div className="col-sm-2 col-md-2">
                <a className="fw-bold fs--1 mt-4" href="#!">
                  <span className="text-danger-300" data-feather="minus-circle"></span>
                </a>
              </div>

              <div className="col-sm-6 col-md-6">
                <div className="form-floating">
                  <input className="form-control" id="floatingInputBudget" type="text" placeholder="value" />
                  <label htmlFor="floatingInputBudget">Character Virtue Development</label>
                </div>
              </div>

              <div className="col-sm-4 col-md-4">
                <div className="form-floating">
                  <input className="form-control" id="floatingInputBudget" type="text" placeholder="key" />
                  <label htmlFor="floatingInputBudget">cvd</label>
                </div>
              </div>

              <div className="col-sm-2 col-md-2">
                <a className="fw-bold fs--1 mt-4" href="#!">
                  <span className="text-danger-300" data-feather="minus-circle"></span>
                </a>
              </div>

              <div className="col-sm-6 col-md-6">
                <div className="form-floating">
                  <input className="form-control" id="floatingInputBudget" type="text" placeholder="value" />
                  <label htmlFor="floatingInputBudget">Human Sciences</label>
                </div>
              </div>

              <div className="col-sm-4 col-md-4">
                <div className="form-floating">
                  <input className="form-control" id="floatingInputBudget" type="text" placeholder="key" />
                  <label htmlFor="floatingInputBudget">hs</label>
                </div>
              </div>

              <div className="col-sm-2 col-md-2">
                <a className="fw-bold fs--1 mt-4" href="#!">
                  <span className="" data-feather="plus-circle"></span>
                </a>
              </div>

              <h3 className="mb-2 mt-6">Grantee Types</h3>
              <div className="col-sm-6 col-md-6">
                <div className="form-floating">
                  <input className="form-control" id="floatingInputBudget" type="text" placeholder="value" />
                  <label htmlFor="floatingInputBudget">Non-profit Organization</label>
                </div>
              </div>

              <div className="col-sm-4 col-md-4">
                <div className="form-floating">
                  <input className="form-control" id="floatingInputBudget" type="text" placeholder="key" />
                  <label htmlFor="floatingInputBudget">npo</label>
                </div>
              </div>

              <div className="col-sm-2 col-md-2">
                <a className="fw-bold fs--1 mt-4" href="#!">
                  <span className="text-danger-300" data-feather="minus-circle"></span>
                </a>
              </div>

              <div className="col-sm-6 col-md-6">
                <div className="form-floating">
                  <input className="form-control" id="floatingInputBudget" type="text" placeholder="value" />
                  <label htmlFor="floatingInputBudget">Educational Institution</label>
                </div>
              </div>

              <div className="col-sm-4 col-md-4">
                <div className="form-floating">
                  <input className="form-control" id="floatingInputBudget" type="text" placeholder="key" />
                  <label htmlFor="floatingInputBudget">ei</label>
                </div>
              </div>

              <div className="col-sm-2 col-md-2">
                <a className="fw-bold fs--1 mt-4" href="#!">
                  <span className="text-danger-300" data-feather="minus-circle"></span>
                </a>
              </div>

              <div className="col-sm-6 col-md-6">
                <div className="form-floating">
                  <input className="form-control" id="floatingInputBudget" type="text" placeholder="value" />
                  <label htmlFor="floatingInputBudget">Government Agency</label>
                </div>
              </div>

              <div className="col-sm-4 col-md-4">
                <div className="form-floating">
                  <input className="form-control" id="floatingInputBudget" type="text" placeholder="key" />
                  <label htmlFor="floatingInputBudget">ga</label>
                </div>
              </div>

              <div className="col-sm-2 col-md-2">
                <a className="fw-bold fs--1 mt-4" href="#!">
                  <span className="" data-feather="plus-circle"></span>
                </a>
              </div>

              <div className="col-12 gy-6">
                <div className="row g-3 justify-content-end">
                  <div className="col-auto">
                    <button
                      type="button"
                      className="btn btn-phoenix-primary px-5"
                      onClick={() => {
                        navigate(-1)
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                  <div className="col-auto">
                    <button type="button" className="btn btn-primary px-5 px-sm-15">
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>

        <Footer />
      </div>
    </PrivateLayout>
  )
}

export default Settings
